
































































































































































































































































































































































































































































































































































import { ShipmentRequest } from '@/models/shipmentRequest';
import { cloneDeep } from 'lodash';
import Vue from 'vue';
import dateFormat from '@/utils/dateFormat';
import { axios } from '@/plugins/axios';
import pdf from 'vue-pdf';
import { Shipment } from '@/models/shipment';
import ImageDialog from '../../common/ImageDialog.vue';

export default Vue.extend({
  components: {
    ImageDialog,
    pdf
  },
  data() {
    return {
      dialog: false,
      shipmentRequest: new ShipmentRequest(),
      adminId: 1
    };
  },
  methods: {
    dateFormat,

    open(shipmentRequest: ShipmentRequest) {
      this.shipmentRequest = cloneDeep(shipmentRequest);
      this.dialog = true;
    },

    getUserTypeText(userType: string) {
      if (userType == 'C') {
        return 'Customer';
      } else if (userType == 'A') {
        return 'Admin';
      } else {
        return 'Employee';
      }
    },

    getUserTypeColor(userType: string) {
      if (userType == 'C') {
        return 'primary';
      } else if (userType == 'A') {
        return 'red';
      } else {
        return 'success';
      }
    },

    getPickupParishText(parishType: string) {
      if (parishType == 'MBJ') {
        return 'Montego Bay';
      } else {
        return 'Kingston';
      }
    },

    viewImage(image: string) {
      (this.$refs as any).imageDialog.open(image);
    },

    downloadImage(url: string) {
      const fileTypeIndex = url.lastIndexOf('.');
      const fileType = url.slice(fileTypeIndex, url.length);

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute(
          'download',
          `${
            (this.shipmentRequest.package! as Shipment).description
          } image.${fileType}`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    }
  }
});
